// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-27b6ed8a","scoped":true,"hasInlineConfig":false}!./src/components/nudge-console/analytics/CampaignAnalytics.css
// module id = miAG
// module chunks = 1